module.exports = __webpack_public_path__ + "static/media/Heart Problem.5297f8f3.webp";